
import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOMetadata = () => {
  return (
    <Helmet>
      <title>Over Ons | Afsprakenmaker - Het #1 B2B Callcenter in Vlaanderen</title>
      <meta name="description" content="Ontdek het verhaal achter Afsprakenmaker, het toonaangevende B2B callcenter in Vlaanderen. Leer over onze missie, ons team, en hoe we al meer dan 10 jaar bedrijven helpen met effectieve telemarketing en verkoopstrategieën." />
      <meta name="keywords" content="B2B callcenter Vlaanderen, Afsprakenmaker, telemarketing België, B2B verkoop, sales agency, verkoopspecialisten, sales team, Vlaams telemarketing" />
      <link rel="canonical" href="https://afsprakenmaker.be/over-ons" />
      
      {/* Open Graph / Social Media */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content="Over Ons | Afsprakenmaker - #1 B2B Callcenter in Vlaanderen" />
      <meta property="og:description" content="Ontdek hoe Afsprakenmaker, het beste B2B callcenter in Vlaanderen, sinds 2014 bedrijven helpt groeien met effectieve telemarketing en innovatieve verkooptools." />
      <meta property="og:url" content="https://afsprakenmaker.be/over-ons" />
      <meta property="og:image" content="https://afsprakenmaker.be/lovable-uploads/team-image.jpg" />
      
      {/* Structured Data */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Afsprakenmaker",
            "alternateName": "Het #1 B2B Callcenter in Vlaanderen",
            "url": "https://afsprakenmaker.be",
            "logo": "https://afsprakenmaker.be/logo-2026.png",
            "description": "Professionele telemarketing en verkoopondersteuning voor bedrijven in België. Als toonaangevend B2B callcenter helpen wij KMO's om meer afspraken te genereren.",
            "foundingDate": "2014",
            "founders": [
              {
                "@type": "Person",
                "name": "Jan Vermeulen",
                "jobTitle": "Oprichter & CEO"
              }
            ],
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Aalst",
              "addressRegion": "Vlaanderen",
              "postalCode": "9300",
              "addressCountry": "BE"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+32-800-90500",
              "contactType": "customer service",
              "email": "info@afsprakenmaker.be",
              "availableLanguage": ["Dutch", "English"]
            },
            "sameAs": [
              "https://www.facebook.com/afsprakenmaker",
              "https://www.linkedin.com/company/afsprakenmaker",
              "https://www.instagram.com/afsprakenmaker.be"
            ],
            "areaServed": {
              "@type": "GeoCircle",
              "geoMidpoint": {
                "@type": "GeoCoordinates",
                "latitude": 50.9384,
                "longitude": 3.9959
              },
              "geoRadius": "100 km"
            }
          }
        `}
      </script>
    </Helmet>
  );
};

export default SEOMetadata;
